import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

/**
 * for this page
 */
class SubNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        content: [
            {
                title: '热点板块',
                url: '#',
            },
            {
                title: '热点板块',
                url: '#',
            },
            {
                title: '热点板块',
                url: '#',
            },
            {
                title: '热点板块',
                url: '#',
            },
            {
                title: '热点板块',
                url: '#',
            },
            {
                title: '热点板块',
                url: '#',
            },
            {
                title: '热点板块',
                url: '#',
            },
        ],
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.subNav}>
                <div className={styles.label}>{'数据中心 >>'}</div>
                {content &&
                    content.length &&
                    content.map((item, index) => {
                        return (
                            <a
                                href={item.url}
                                className={styles.link}
                                key={index}
                                target="_blank"
                                style={{ marginRight: index + 1 === content.length ? 0 : 70 }} rel="noreferrer">
                                {item.title}
                            </a>
                        );
                    })}
            </div>
        );
    }
}

export default SubNav;
